import React, { useEffect, useState } from 'react';
import {Link, useParams, useNavigate} from 'react-router-dom';
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import AdminCashierAPI from "../../../apis/adminApi/AdminCashierAPI";
import FormContentLoader from "../../loaders/FormContentLoader";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";


const AdminEditCashOut = () => {

    const { formState } = useForm();
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [loading, setLoading] = useState(true);
    let {cashOutId} = useParams();
    const [accounts, setAccounts] = useState([]);
    const [sources, setSources] = useState([]);

    const [showLoader, setShowLoader] = useState(false);

    const [cashOut, setCashOut] = useState({
        currency : "",
        amount : "" ,
        created_at : "",
        beneficiary : "",
        motif : "",
        account : "",
        source : "",
        id: cashOutId
    });

    const [editing, setEditing] = useState(false);

    const [errors, setErrors] = useState({
        currency : "",
        amount : "" ,
        created_at : "",
        beneficiary : "",
        motif : "",
        account : "",
        source : "",
    });


    //Recuperation d'une facture
    const fetchCashOneCashOut = async id => {
        try{
            const { currency, amount, created_at, beneficiary, motif, account, source, id } = await AdminCashierAPI.findOneCashOut(cashOutId);
            setCashOut({ currency, amount, created_at, beneficiary, motif, account, source, id });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger l'enregistrement !");
            navigate("/admin/cashier/cashOuts");
        }
    };

    const getCashAccounts = async () => {
        try{
            const data =  await AdminCashierAPI.getCashAccounts();
            setAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };

    const getCashSources = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };


    useEffect(() => {
        setEditing(true);
        fetchCashOneCashOut(cashOutId);
        getCashAccounts();
        getCashSources();
    }, [cashOutId]);


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCashOut({...cashOut, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await AdminCashierAPI.storeCashOut(cashOut);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Sortie modifiée avec succès");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification !");
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-7">
                    {loading && <FormContentLoader />}

                    {!loading && <form onSubmit={handleSubmit}>
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Modifier un compte source</h5>
                                <Field
                                    name="amount"
                                    type="number"
                                    error={errors.amount}
                                    value={cashOut.amount}
                                    onChange={handleChange}
                                    label="Montant"
                                    placeholder="000"
                                />

                                <label htmlFor="devise" className="form-label">Devise</label>
                                <select
                                    className={"form-select-sm form-control mb-2 " + ( errors.currency && "is-invalid")}
                                    //size={(buses.length)}
                                    name="currency"
                                    label="Devise"
                                    disabled="disabled"
                                    value={cashOut.currency}
                                    onChange={handleChange}
                                >

                                    <option value="">Choisir...</option>
                                    <option value="FC">CDF</option>
                                    <option value="USD">USD</option>
                                </select>
                                {errors.currency && <div className="invalid-feedback mb-4">{errors.currency}</div>}

                                <Field
                                    name="motif"
                                    error={errors.motif}
                                    value={cashOut.motif}
                                    onChange={handleChange}
                                    label="Motif"
                                    placeholder="Saisir le motif de sortie"
                                    //autoComplete="off"
                                />

                                <Field
                                    name="beneficiary"
                                    error={errors.beneficiary}
                                    value={cashOut.beneficiary}
                                    disabled="disabled"
                                    onChange={handleChange}
                                    label="Bénéficiaire"
                                    placeholder="Saisir le bénéficiaire"
                                    autoComplete="off"
                                />

                                <label htmlFor="account" className="form-label">Comptes</label>
                                {!loading &&
                                    <select
                                        className={"form-select-sm form-control mb-2 " + ( errors.account && "is-invalid")}
                                        //size={(buses.length)}
                                        name="account"
                                        id="account"
                                        value={cashOut.account}
                                        onChange={handleChange}
                                    >

                                        <option value="">Choisir...</option>
                                        {accounts && accounts.map((account) => (
                                            <option key={account.id} value={account.compte}>
                                                {account.compte}</option>
                                        ))
                                        }
                                    </select>
                                }
                                {errors.account && <div className="invalid-feedback mb-4">{errors.account}</div>}

                                <label htmlFor="source" className="form-label">Source</label>
                                {!loading &&
                                    <select
                                        className={"form-select-sm form-control mb-2 " + ( errors.source && "is-invalid")}
                                        //size={(buses.length)}
                                        name="source"
                                        id="source"
                                        value={cashOut.source}
                                        onChange={handleChange}
                                    >

                                        <option value="">Choisir...</option>
                                        {sources && sources.map((source) => (
                                            <option key={source.id} value={source.name}>
                                                {source.name}</option>
                                        ))
                                        }
                                    </select>
                                }
                                {errors.account && <div className="invalid-feedback mb-4">{errors.account}</div>}

                                <Field
                                    name="created_at"
                                    type="date"
                                    error={errors.created_at}
                                    value={cashOut.created_at}
                                    onChange={handleChange}
                                    label="Date"
                                    autoComplete="off"
                                />
                                <hr/>

                                <MyButton
                                    text="Modifier"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                {cashOut.currency === "USD" ? <Link to="/admin/cashier/rapport/cash/out/usd" className="btn btn-info mx-2">Revenir aux sorties</Link> :
                                    <Link to="/admin/cashier/rapport/cash/out/cdf" className="btn btn-info mx-2">Revenir aux sorties</Link>}
                            </div>
                        </div>
                    </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default AdminEditCashOut;
